var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 8,
  viewBox: "0 0 11 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1219_2431)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.429688 0.804633C0.429688 0.680189 0.463021 0.563522 0.521354 0.446855C0.663021 0.190189 0.946354 0.0268555 1.26302 0.0268555H9.59635C9.90469 0.0268555 10.1964 0.190189 10.338 0.446855C10.4797 0.703522 10.4547 1.01463 10.2714 1.25574L6.37969 6.70019C6.22135 6.90241 5.97135 7.02686 5.70469 7.02686C5.43802 7.02686 5.17969 6.90241 5.02969 6.70019L0.588021 1.25574C0.488021 1.12352 0.429688 0.960189 0.429688 0.804633Z",
  fill: "#414141"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1219_2431"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 7,
  fill: "white",
  transform: "translate(0.429688 0.0268555)"
})))));
export default SvgIconDownArrow;